import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CompanyActions from '../_actions/company';
import { Company } from '../_models';

export interface CompanyState extends EntityState<Company> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Company> = createEntityAdapter<Company>();

const initialState: CompanyState = adapter.getInitialState({
  loading: false,
  error: null,
});

const companyReducer = createReducer(
  initialState,

  on(CompanyActions.loadCompanies, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CompanyActions.loadCompaniesSuccess, (state, { companies }) =>
    adapter.setAll(companies, { ...state, loading: false })
  ),

  on(CompanyActions.loadCompaniesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CompanyActions.addCompanySuccess, (state, { company }) => adapter.addOne(company, state)),

  on(CompanyActions.updateCompanySuccess, (state, { company }) =>
    adapter.upsertOne(company, state)
  ),

  on(CompanyActions.deleteCompanySuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    CompanyActions.addCompanyFailure,
    CompanyActions.updateCompanyFailure,
    CompanyActions.deleteCompanyFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CompanyState | undefined, action: Action) {
  return companyReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
